module.exports = __webpack_public_path__ + "static/media/app.a9786582.png";